module.exports = __webpack_public_path__ + "static/img/icon_vintage.686e7d84.svg";